import React from "react";
import closeBtn from "../../../src/assets/images/crossbtn.png";
import bgImg from "../../assets/images/notificationImg.png"
import Styles from "./popup.module.scss";

let propsData = {
  isOpen: false,
  setClose: () => {},
  data: " Your anticipated voyage awaits behind this door. Before getting absorbed by a series of unexpected adventures, prepare for your expedition to the moon by scanning the QR codes",
};

export const NotificationPopup = ({ link, dataProps, handlePopUpClose }) => {

  const handleTicketClick = () => {
    window.open(link ,"_blank")
  }
  
  return (
    <>
      <div className={Styles.overlay}>
        <div style={{
          backgroundImage: `url(${bgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%"
        }} className={Styles.popupContainer}>
          
          <img
            className={Styles.cross}
            onClick={handlePopUpClose}
            src={closeBtn}
            alt="close"
          />

          <section>
            <div className={Styles.dataProps}>
              {dataProps.isOpen ? dataProps.data : propsData.data}
            </div>
           
            {/* <div className={Styles.dataPropsLink}>{link ? <a target="_blank">{link}</a> : null}</div> */}
          </section>
          {link && (
              <button 
              onClick={handleTicketClick}
              className={Styles.Btn}
                style={{
                  backgroundImage: `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKEAAAAuBAMAAACymWSIAAAAElBMVEUAAACxJTWvIDCxJTWvIDixJTUedhOkAAAABXRSTlMAzxDfIM2tookAAABvSURBVEjH7c5BDYAAEAPB5jxUQB3wQAASSEj9W+EBEvZ5K2Cy+hoX6tZXCotjWkxhcUyLKSyOaTGFxTEtprA4psUUFse0mNKicbErrrjiiiuu+HfQ4nPR4inhi8IXhS8KXxS+KHxR+KLwReGLwhdfMNGzsst+YU0AAAAASUVORK5CYII=)`,
                  backgroundRepeat: `no-repeat`,
                  backgroundSize: `cover`,
                  margin: "1rem auto",
                }}
              >
                Ticket Options
              </button>
            )}
          <div></div>
        </div>
      </div>
    </>
  );
};
